import { FormErrors } from 'types'
import { useMemo } from 'react'
import { useForm, useFormValidator, useMutationBasedFormSubmitHandlers } from 'hooks/form'
import { graphql } from 'react-relay'

interface IContactFormFields {
  email: string
}

function validate(values: IContactFormFields) {
  const errors: FormErrors<IContactFormFields> = {}

  if (!values.email) errors._error = 'Email is required'
  if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  return errors
}

function useDefaultValues() {
  return useMemo(() => ({ email: '' }), [])
}

export function useContactForm() {
  return useForm<IContactFormFields, any>({
    resolver: useFormValidator(validate),
    submitHandlers: useMutationBasedFormSubmitHandlers(graphql`
        mutation useContactForm_Mutation($input: UpdateUserInput!) {
          updateUser(input: $input) {
            user {
              ...ChatThreadMessages_User
            }
          }
        }
    `, values => ({ input: values }), {
      successMessage: 'Email was added',
      verifySuccess(result) {
        return Boolean(result?.updateUser?.user)
      },
    }),
    defaultValues: useDefaultValues(),
  })
}
